export enum ETipType {
  VIDEO = 'video',
  CAROUSEL = 'carousel',
  TEXT = 'text',
}
export interface ITip {
  key: string;
  type: ETipType;
  body: string;
}

export interface IVideoTip extends ITip {
  type: ETipType.VIDEO;
  title: string;
  video: {
    provider: string;
    link: string;
  };
  isInsideCarousel?: boolean;
}

export interface ITextTip extends ITip {
  type: ETipType.TEXT;
}

export interface ICarouselTip extends ITip {
  type: ETipType.CAROUSEL;
  pages: (IVideoTip | ITextTip)[];
}

export type TTip = IVideoTip | ITextTip | ICarouselTip;
